<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline='true'>
          <el-form-item label="人员名称:">
            <el-input v-model="filters.userName" @input="(e) => (filters.userName = utils.validForbid(e))" placeholder="请输入人员名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="专家类型:">
            <el-select v-model="filters.expertType" clearable>
              <el-option v-for="item in expertOptions" :key="item.id" :label="item.value"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 列表 -->
    <el-table id="exportTab" :data="tableData" border style="width: 100%" v-loading="listLoading"
               :highlight-current-row='true'>
      <el-table-column type='index' label="序号" width='50' align="center"></el-table-column>
      <el-table-column prop="userName" align="center" label="姓名"></el-table-column>
      <el-table-column prop="totalSpendTime" align="center" label="总花费时间（小时）"></el-table-column>
      <el-table-column prop="projectNum" align="center" label="项目数量">
        <template slot-scope="scope">
          <div style="text-align: center;">
            <!--显示提示文字 el-tooltip-->
            <!--            <el-tooltip :content="scope.row.userName" placement="left">-->
            <el-button type="text" @click="getProject(scope.row)">
              {{scope.row.projectNum}}
            </el-button>
            <!--            </el-tooltip>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="项目明细"
               :visible.sync="numDialog"
               v-model="numDialog"
               :close-on-click-modal="false"
               :width="'60%'">
      <el-table id="exportTab" :data="tableDataList" border style="width: 100%" v-loading="listLoading"
                :highlight-current-row='true'>
        <el-table-column type='index' label="序号" width='50' align="center"></el-table-column>
        <el-table-column prop="projectName" align="center" label="项目名称"></el-table-column>
        <el-table-column prop="flowName" align="center" label="项目阶段"></el-table-column>
        <el-table-column prop="spendTime" align="center" label="花费时间（小时）"></el-table-column>
        <el-table-column prop="" align="center" label="明细">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <!--显示提示文字 el-tooltip-->
              <!--            <el-tooltip :content="scope.row.userName" placement="left">-->
              <el-button type="text" @click="getTableProject(scope.row)">
                {{'查看'}}
              </el-button>
              <!--            </el-tooltip>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="明细"
               :visible.sync="tableProject"
               v-model="tableProject"
               :close-on-click-modal="false"
               :width="'60%'">
      <el-table id="exportTab" :data="projectListDetail" border style="width: 100%" v-loading="listLoading"
                :highlight-current-row='true'>
        <el-table-column type='index' label="序号" width='50' align="center"></el-table-column>
        <el-table-column prop="behavior" align="center" label="行为"></el-table-column>
        <el-table-column prop="createTime" align="center" label="创建时间"></el-table-column>

      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import util from '../../../util/date'
import Toolbar from '../../components/Toolbar'
import { getButtonList } from '../../promissionRouter'
import {
  getUserBehaviorLogByWorkFlowNodeId,
  getUserProjectBehaviorList,
} from '@/api/api'

export default {
  components: { Toolbar },
  data () {
    return {
      tableDataList:[],
      buttonList: [],
      needData: '',
      filters: {
        expertType: undefined,
        userName:undefined,
      },
      tableData: [],
      listLoading: false,
      expertOptions: [{
        'id': 62,
        'key': 0,
        'value': '驻场图审工程师',
        'sort': 1,
        'remark': ''
      }, {
        'id': 63,
        'key': 1,
        'value': '在线图审专家',
        'sort': 2,
        'remark': ''
      }, {
        'id': 162,
        'namespace': 'CommonService.OrgPermission.ExpertIdentity',
        'key': 5,
        'value': '技术部专家',
        'sort': 6,
        'remark': ''
      }],//专家类型
      projectId: '',
      numDialog:false,
      utils: '',
      tableId:undefined,
      tableProject:false,
      projectListDetail:[],
    }
  },
  created () {
    this.utils = util
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : []
    this.buttonList = getButtonList(this.$route.path, routers)
    this.getDataList()
  },
  methods: {
    getProject(val){
      console.log(val,'val')
      this.tableDataList = val.projectList
      this.numDialog = true;
    },
    async getTableProject(val){
      console.log(val,'projectval')
      let params = {
        userId:val.userId,//用户ID
        workflowNodeId:val.workFlowNodeId,//项目流程节点
      }
      const res = await  getUserBehaviorLogByWorkFlowNodeId(params)
      if (res.data.success){
        this.projectListDetail = res.data.response
      }
      console.log(res,'resjjjj')
      this.tableProject = true;
    },
    callFunction (item) {
      this[item.func].apply(this, item)
    },

    handleSelect (item) {
      this.tableId = item.userId
    },
    querySearchAsync (queryString, cb) {


      this.userList = this.tableData
      let userList = this.userList
      let results = queryString ? userList.filter(this.createStateFilter(queryString)) : userList
      cb(results)


    },
    createStateFilter (queryString) {
      return (state) => {
        return (state.name.indexOf(queryString) === 0)
      }
    },
    // 查询
    getListdata () {
      this.getDataList()
    },
    // 列表查询接口
    getDataList () {
      getUserProjectBehaviorList().then(res => {
        const result = res.data;
        console.log(result,'result1')
        if (result.success) {
          const arr = result.response.filter(item=>item.expertType === 62|| item.expertType ===63|| item.expertType ===162)
          console.log(arr,'arr')
          if (this.filters.userName&&this.filters.expertType){
            const res = arr.filter(item=>item.userName.includes(this.filters.userName))
            this.tableData = res.filter(item=>item.expertType===this.filters.expertType)
          }
          else if (this.filters.userName){
            this.tableData = arr.filter(item=>item.userName.includes(this.filters.userName))
          }else if (this.filters.expertType){
            // console.log()
            this.tableData = arr.filter(item=>item.expertType === this.filters.expertType)
          }
          else {
            this.tableData = arr;
          }
        }
      });
    },

  }
}
</script>

<style lang="stylus" scoped>
.custom-div {
  margin-bottom: 15px; /* Adds 15px margin outside the div */
  font-size : 16px
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
